'use strict';

const $ = jQuery.noConflict();
$(function() {
	const brandsCards = {
		init: function() {
			this.cacheDOM();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$cards = $('.js-brands-card');
		},

		bindEvents: function() {
			this.$cards.on('mouseenter', (e) => {
				if (window.innerWidth <= 991) {
					return;
				}
				$(e.currentTarget).addClass('brands__card--hover');
			});

			this.$cards.on('mouseleave', (e) => {
				$(e.currentTarget).removeClass('brands__card--hover');
			});
		},
	};

	brandsCards.init();
});
